 (function() {

    // Check selected variant to see if it exists and is available, and auto-select the first available option if not
    document.addEventListener("variant:change", function(e) {
        if (!e.detail.variant || !e.detail.variant.available) {
            let options = document.querySelectorAll('.variant-picker__option-values input');
            options.forEach((option) => {
                if (option.checked) {
                    let swatch = option.nextElementSibling;
                    if (swatch && swatch.classList.contains('is-disabled')) {
                        let container = option.parentElement;
                        let firstSwatch = container.querySelector('.block-swatch:not(.is-disabled)');
                        if (firstSwatch) {
                            firstSwatch.click();
                        }
                    }
                }
            });
        } else {
            let packagingImgs = document.getElementById('product-img-data');
            if (packagingImgs) {
                let packagingImgsData = JSON.parse(packagingImgs.textContent);
                // Debug Log 
                // console.log('Packaging Images Data:', packagingImgsData);
                let selectedOption = e.detail.variant.public_title;
                // Debug Log
                // console.log('Selected Option:', selectedOption);
                if (selectedOption.includes(' / Alu')) {
                    selectedOption = 'Alu';
                }
                let imgData = packagingImgsData.find((d) => 
                  d.name.toLowerCase().trim() === selectedOption.toLowerCase().trim()
                );
                // Debug Log
                // console.log('Image Data for Selected Option:', imgData);
                if (imgData) {
                    let imgContainers = document.querySelectorAll('[data-packaging-image="true"]');
                    imgContainers.forEach((el) => {
                        let img = el.querySelector('img');
                        if (img) {
                            img.src = imgData.packaging_image_url;
                            if (imgData.show_packaging_image) {
                                el.style.display = "block";
                            } else {
                                el.style.display = "none";
                            }
                        }
                    });
                }
            }
        }
    });

})();

//Product Card Funktionen
//Add-to-cart Element in der Produkt Cart

document.addEventListener('DOMContentLoaded', function() {
  
  if (window.location.pathname.includes('/products/')) {
    console.log('handleFormSubmit wird auf Produktseiten nicht ausgeführt.');
    return;
  }
  // =============================================================================
  // EVENT DELEGATION - Funktioniert für alle Elemente, auch dynamisch hinzugefügte
  // =============================================================================
  
  // Delegierte Events für Swatch-Auswahl
  document.addEventListener('click', function(e) {
    if (e.target.matches('.block-swatch') && !e.target.disabled) {
      selectVariant(e.target);
    }
  });
  
  // Delegierte Events für Quantity-Buttons
  document.addEventListener('click', function(e) {
    if (e.target.matches('.quantity-selector__button')) {
      e.preventDefault();
      var delta = e.target.getAttribute('aria-label').includes('verringern') ? -1 : 1;
      updateQuantity(e.target, delta);
    }
  });
  
  // NEU: Delegierte Events für Cart Remove Buttons
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-remove-item], .cart-item__remove, .cart-drawer__remove')) {
      // Nach dem Remove den Cart Count aktualisieren
      setTimeout(refreshCartUI, 500);
    }
  });
  
  // Delegierte Events für Form-Submit
  document.addEventListener('submit', function(e) {
    if (e.target.matches('form.product-form, form[id^="product-form-"]')) {
      handleFormSubmit(e);
    }
  });
  
  // =============================================================================
  // FORM SUBMIT HANDLER
  // =============================================================================
  let cartRequestRunning = false;

  function formIsNotPurchasable(form) {
    return !!(form && (form.dataset.notPurchasable === 'true' || form.querySelector('[data-block-purchase]')));
  }

  function handleFormSubmit(e) { 
    e.preventDefault();
    var form = e.target;
    if (formIsNotPurchasable(form)) return;
    var submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn || submitBtn.disabled || cartRequestRunning) return; // Prüfen, ob schon aktiv

    cartRequestRunning = true; // Anfrage läuft
    var originalBtnHtml = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.innerHTML = '<span class="loading-dots"><span>.</span><span>.</span><span>.</span></span>';

    var formData = new FormData(form);

    fetch(form.action, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Fehler beim Hinzufügen zum Warenkorb');
      return response.json();
    })
    .then(refreshCartUI)
    .then(function(cart) {
      if (cart) {
        if (isMobile()) showMobilePopup();
        else openCartDrawer();
      }
    })
    .catch(function(error) {
      console.error('Cart error:', error);
      alert('Fehler beim Hinzufügen zum Warenkorb. Bitte versuchen Sie es erneut.');
    })
    .finally(function() {
      cartRequestRunning = false; // Anfrage wieder freigeben
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-disabled');
      submitBtn.innerHTML = originalBtnHtml;
    });
  }

  
  // =============================================================================
  // MUTATION OBSERVER - Erkennt neue Elemente (Recently Viewed)
  // =============================================================================
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          initializeFormsInElement(node);
        }
      });
    });
  });
  
  // Observer starten
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  // =============================================================================
  // INITIALISIERUNG
  // =============================================================================
  
  function initializeFormsInElement(element) {
    // Forms in dem Element finden
    var forms = [];
    if (element.querySelectorAll) {
      forms = element.querySelectorAll('form.product-form, form[id^="product-form-"]');
    }
    forms.forEach(initializeForm);
    
    // Prüfen ob das Element selbst ein Form ist
    if (element.matches && element.matches('form.product-form, form[id^="product-form-"]')) {
      initializeForm(element);
    }
  }
  
  function initializeForm(form) {
    if (form.dataset.ajaxInit === 'true') return;
    form.dataset.ajaxInit = 'true';
    
    // Initialen Swatch auswählen
    var activeBtn = form.querySelector('.block-swatch.active');
    var firstAvailableBtn = form.querySelector('.block-swatch:not(.button--disabled)');
    
    if (activeBtn && !activeBtn.disabled) {
      selectVariant(activeBtn);
    } else if (firstAvailableBtn) {
      selectVariant(firstAvailableBtn);
    }
  }
  
  // Existierende Forms beim Laden initialisieren
  document.querySelectorAll('form.product-form, form[id^="product-form-"]').forEach(initializeForm);
  
  // =============================================================================
  // HELPER FUNCTIONS
  // =============================================================================
  
  function selectVariant(btn) {
    var form = btn.closest('form');
    if (!form) return;

    var variantAvailable = btn.dataset.variantAvailable === 'true';
    
    // Swatches aktiv/inaktiv
    form.querySelectorAll('.block-swatch').forEach(function(s){ s.classList.remove('active'); });
    btn.classList.add('active');

    // Hidden-Input updaten
    var variantId = btn.dataset.variantId;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;
    
    // Preis-Updates
    var price = btn.dataset.variantPrice;
    var comparePrice = btn.dataset.variantCompareprice;
    
    var priceElem = form.querySelector('.price--sale') || form.querySelector('.price.price--large');
    var b2bPriceElem = form.querySelector('.product-net-price');
    
    if (priceElem && price) {
      if(b2bPriceElem) {
        priceElem.textContent = price + ' inkl. MwSt.';
      } else {
        priceElem.textContent = price;
      }
    }
    
    // Compare Price Update
    var compareElem = form.querySelector('.price--regular');
    if (compareElem) {
      if (comparePrice) {
        compareElem.textContent = comparePrice;
        compareElem.style.display = '';
      } else {
        compareElem.textContent = '';
        compareElem.style.display = 'none';
      }
    }

    // B2B Preis Update
    if (b2bPriceElem && price) {
      var numericPrice = parseFloat(price.replace(/[^0-9,.-]/g, '').replace(',', '.'));
      
      if (!isNaN(numericPrice)) {
        var taxRate = parseFloat(btn.dataset.taxRate) || 7.0;
        var taxDecimal = taxRate / 100.0;
        var divisor = 1.0 + taxDecimal;
        var netPrice = numericPrice / divisor;
        var netPriceDisplay = netPrice.toFixed(2).replace('.', ',');
        
        b2bPriceElem.innerHTML = netPriceDisplay + ' €' + ' zzgl. MwSt.';
      }
    }

    // Grundpreis Update mit B2B-Prüfung
    var basePrice = btn.dataset.variantBaseprice;
    var baseElem = form.querySelector('.unit-price');
    if (baseElem) {
      if (basePrice) {
        // Prüfen ob B2B-Kunde (durch Vorhandensein des B2B-Nettopreis-Elements)
        var isB2B = form.querySelector('.product-net-price');
        var basePriceText = '(' + basePrice + ' / kg';
        if (isB2B) {
          basePriceText += ' inkl. MwSt.';
        }
        basePriceText += ')';
        
        baseElem.textContent = basePriceText;
        baseElem.style.display = '';
      } else {
        baseElem.style.display = 'none';
      }
    }

    // Verfügbarkeits-Update
    var quantitySelector = form.querySelector('.quantity-selector');
    var cartButton = form.querySelector('[data-cart-button]');
    
    if (formIsNotPurchasable(form)) {
      if (quantitySelector) quantitySelector.style.display = 'none';
      if (cartButton) {
        cartButton.disabled = true;
        cartButton.setAttribute('aria-disabled', 'true');
        cartButton.classList.add('button--disabled');
        var cartLabel = cartButton.querySelector('span');
        if (cartLabel) cartLabel.textContent = 'nicht kaufbar';
      }
    } else if (quantitySelector) {
      quantitySelector.style.display = variantAvailable ? '' : 'none';
    }
    
    if (cartButton && !formIsNotPurchasable(form)) {
      if (variantAvailable) {
        cartButton.disabled = false;
        cartButton.removeAttribute('aria-disabled');
        cartButton.classList.remove('button--disabled');
        cartButton.querySelector('span').textContent = 'In den Warenkorb';
      } else {
        cartButton.disabled = true;
        cartButton.setAttribute('aria-disabled', 'true');
        cartButton.classList.add('button--disabled');
        cartButton.querySelector('span').textContent = 'nicht verfügbar';
      }
    }

    // Deep-Link Update und Rabatt-Badge der angezeigten Variante
    var cardEl = btn.closest('product-card') || btn.closest('.product-card');
    if (cardEl) {
      cardEl.querySelectorAll('a[data-instant]').forEach(function(a){
        var base = a.getAttribute('href').split('?')[0];
        a.setAttribute('href', base + '?variant=' + variantId);
      });

      if (cardEl.hasAttribute('data-show-badges')) {
        var discountLabel = (btn.dataset.variantDiscountLabel || '').trim();
        var saleBadge = cardEl.querySelector('on-sale-badge');
        var badgeList = cardEl.querySelector('.product-card__badge-list');

        if (discountLabel) {
          if (!badgeList) {
            badgeList = document.createElement('div');
            badgeList.className = 'product-card__badge-list';
            var figure = cardEl.querySelector('.product-card__figure');
            if (figure) cardEl.insertBefore(badgeList, figure);
            else cardEl.prepend(badgeList);
          }
          if (!saleBadge) {
            saleBadge = document.createElement('on-sale-badge');
            saleBadge.className = 'data-wpd-hide badge badge--on-sale';
            badgeList.appendChild(saleBadge);
          }
          saleBadge.textContent = discountLabel;
          saleBadge.style.display = '';
        } else if (saleBadge) {
          saleBadge.remove();
          if (badgeList && badgeList.children.length === 0) badgeList.remove();
        }
      }
    }
  }

  function updateQuantity(btn, delta) {
    var form = btn.closest('form');
    if (!form) return;
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) return;
    var current = parseInt(qtyInput.value, 10) || 1;
    var next = current + delta;
    if (next < 1) next = 1;
    qtyInput.value = next;
  }

  function showMobilePopup() {
    var popup = document.createElement('div');
    popup.className = 'mobile-cart-popup';
    popup.textContent = 'Artikel erfolgreich hinzugefügt';
    popup.style.cssText = 'position:fixed;top:50%;left:50%;transform:translateX(-50%);background:#28a745;color:white;padding:12px 24px;border-radius:4px;z-index:9999;';
    document.body.appendChild(popup);
    setTimeout(function() { 
      if (popup.parentNode) popup.parentNode.removeChild(popup); 
    }, 3000);
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.setAttribute('open','');
      drawer.classList.add('is-open');
      document.body.classList.add('no-scroll');
      return;
    }
    var trigger = document.querySelector('[data-drawer-target="cart"], .js-drawer-open-cart') ||
                  document.querySelector('.header__icon--cart, [data-cart-toggle]');
    if (trigger) trigger.click();
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  // NEU: Zentrale Cart Update Funktion
  function refreshCartUI() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error('Fehler beim Abrufen des Warenkorbs');
        return response.json();
      })
      .then(function(cart) {
        // Erweiterte Selektoren für alle möglichen Cart Count Elemente
        var selectors = [
          '.header__cart-count',
          '.cart-count.count-bubble',
          '[data-cart-count]',
          '.cart-drawer__count',
          '.cart-icon__count',
          '.js-cart-count'
        ];
        
        var countEls = document.querySelectorAll(selectors.join(', '));
        
        countEls.forEach(function(el) {
          // Count Attribut setzen
          el.setAttribute('count', cart.item_count);
          
          // Text Content setzen
          if (el.tagName === 'SPAN' || el.tagName === 'DIV') {
            el.textContent = cart.item_count;
          }
          
          // Sichtbarkeit für Bubble-Elemente
          if (el.classList.contains('count-bubble')) {
            el.style.display = cart.item_count > 0 ? '' : 'none';
          }
        });
        
        // Globales Event versenden (für Kompatibilität)
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        
        // Zusätzliches Event für andere Scripte
        document.dispatchEvent(new CustomEvent('cart:updated', { 
          detail: { cart: cart } 
        }));
        
        return cart;
      })
      .catch(function(error) {
        console.error('Cart refresh error:', error);
        return null;
      });
  }

  // Globale Funktionen verfügbar machen
  window.selectVariant = selectVariant;
  window.updateQuantity = updateQuantity;
  window.refreshCartUI = refreshCartUI;  // NEU: Auch diese Funktion global verfügbar machen
  
  // Manuelle Reinitialisierung für externe Aufrufe
  window.reinitializeProductForms = function() {
    document.querySelectorAll('form.product-form, form[id^="product-form-"]').forEach(function(form) {
      if (form.dataset.ajaxInit !== 'true') {
        initializeForm(form);
      }
    });
  };

  // Deep-Link: Variante aus URL auswählen
  var params = new URLSearchParams(window.location.search);
  var variantId = params.get('variant');
  if (variantId) {
    setTimeout(function() {
      var btn = document.querySelector('.block-swatch[data-variant-id="' + variantId + '"]');
      if (btn && !btn.disabled) selectVariant(btn);
    }, 100);
  }
});

// Kitenzo Bundle: persönlichen Text an die Bundle-Positionen hängen.
// Die App legt das Bundle serverseitig in den Warenkorb und verwirft dabei
// alle Properties aus dem Storefront-Formular. Das Bundle-Template übergibt
// den Text daher über sessionStorage. Auf der Warenkorbseite hängt ihn das
// Laden der Seite an; Grußkarten bleiben auf der Seite und rufen dafür
// window.keAttachKitenzoBundleNote auf.
(function() {
  var PENDING_KEY = 'keKitenzoBundleNote';
  var NOTE_PROPERTY = '_card_note';
  var GROUP_PROPERTY = '_card_group';
  var MAX_PASSES = 5;

  function readPending() {
    try {
      return JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function(response) { return response.json(); });
  }

  function lineToken(props) {
    return props._bundle_data || props._unique_id || '';
  }

  function findTarget(cart, known) {
    return (cart.items || []).filter(function(item) {
      var props = item.properties || {};
      var token = lineToken(props);
      if (!token || props[NOTE_PROPERTY] || props._bundle_note) return false;
      if (known.indexOf(token) !== -1 || known.indexOf(props._unique_id) !== -1) return false;
      return !!(props._bundle_data || props._configured_bundle_id);
    })[0];
  }

  // Eine Property-Änderung kann das Bundle in seine Einzelpositionen aufteilen,
  // daher wird der Warenkorb zwischen den Durchläufen neu gelesen.
  function attachNote(note, pass) {
    if (pass >= MAX_PASSES) return Promise.resolve(pass);

    return fetchCart().then(function(cart) {
      var item = findTarget(cart, note.known || []);
      if (!item) return pass;

      var props = Object.assign({}, item.properties);
      var group = props._bundle_group || props.bundle_group || props._card_group || '';
      delete props._bundle_group;
      delete props.bundle_group;
      props[NOTE_PROPERTY] = note.text;
      if (group) props[GROUP_PROPERTY] = group;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, properties: props })
      }).then(function() {
        return attachNote(note, pass + 1);
      });
    });
  }

  function run() {
    var note = readPending();
    if (!note || !note.text) return Promise.resolve(0);

    return attachNote(note, 0)
      .then(function(passes) {
        if (passes > 0) sessionStorage.removeItem(PENDING_KEY);
        if (passes > 0 && window.refreshCartUI) window.refreshCartUI();
        return passes;
      })
      .catch(function(error) {
        console.error('Bundle-Text konnte nicht angehängt werden:', error);
        return 0;
      });
  }

  window.keAttachKitenzoBundleNote = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

(function () {
  if (/\/bundle\/(155190|155434)(?:\/|$)/.test(location.pathname)) return;

  function loadCrossSells(mount) {
    var handle = mount.getAttribute('data-ke-required-handle');
    if (!handle || mount.getAttribute('data-ke-cross-sell-started') === 'true') return;
    mount.setAttribute('data-ke-cross-sell-started', 'true');

    fetch('/products/' + encodeURIComponent(handle) + '?view=ke-cross-sell')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        if (!mount.isConnected) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrapper = doc.querySelector('.cross-sell-wrapper');
        if (!wrapper) {
          mount.remove();
          return;
        }

        var fragment = document.createDocumentFragment();
        Array.prototype.forEach.call(doc.querySelectorAll('style'), function (style) {
          if (style.textContent.indexOf('cross-sell-wrapper') === -1) return;
          fragment.appendChild(document.importNode(style, true));
        });
        fragment.appendChild(document.importNode(wrapper, true));
        mount.replaceWith(fragment);
      })
      .catch(function () {
        if (mount.isConnected) mount.removeAttribute('data-ke-cross-sell-started');
      });
  }

  function findAndLoad() {
    var mount = document.querySelector('[data-ke-required-handle]');
    if (!mount) return;
    loadCrossSells(mount);
  }

  findAndLoad();

  var observer = new MutationObserver(findAndLoad);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-ke-required-handle']
  });
})();
